.root {
    display: block;
}

.picture {
    display: block;
    width: 100%;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.linkText {
    display: block;
    margin-top: var(--spacer-16);
    font: var(--font-nav-16);
}
